function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { flexRender, getCoreRowModel, getExpandedRowModel, useReactTable } from '@tanstack/react-table';
import React, { useEffect } from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "./table";
import { cn } from "../../lib/utils";
import { Empty, Spin } from "../..";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ErrorTypeStr = /*#__PURE__*/function (ErrorTypeStr) {
  ErrorTypeStr["NETWORK"] = "NETWORK";
  ErrorTypeStr["SYSTEM"] = "SYSTEM";
  return ErrorTypeStr;
}({});
var ERROR_INFO = _defineProperty(_defineProperty({}, ErrorTypeStr.SYSTEM, {
  img: '//s1.bycsi.com/bybit/deadpool/image-c1e7653506224aca8575be2d20df897a.png',
  text: 'System error. Please try again later.'
}), ErrorTypeStr.NETWORK, {
  img: '//s1.bycsi.com/bybit/deadpool/image-0ad9ab6dd3d445d5a32a443f630aa983.png',
  text: 'Network error. Please try again later.'
});
export function DataTable(_ref, ref) {
  var _table$getRowModel$ro;
  var columns = _ref.columns,
    data = _ref.data,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 'auto' : _ref$height,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$isLite = _ref.isLite,
    isLite = _ref$isLite === void 0 ? false : _ref$isLite,
    error = _ref.error,
    _ref$rowSplitStyle = _ref.rowSplitStyle,
    rowSplitStyle = _ref$rowSplitStyle === void 0 ? 'normal' : _ref$rowSplitStyle,
    _ref$cellSpaceStyle = _ref.cellSpaceStyle,
    cellSpaceStyle = _ref$cellSpaceStyle === void 0 ? 'normal' : _ref$cellSpaceStyle,
    _ref$showRowSelection = _ref.showRowSelection,
    showRowSelection = _ref$showRowSelection === void 0 ? true : _ref$showRowSelection,
    className = _ref.className,
    _ref$emptyText = _ref.emptyText,
    emptyText = _ref$emptyText === void 0 ? 'No Records' : _ref$emptyText,
    errorText = _ref.errorText,
    onRowClick = _ref.onRowClick,
    renderSubComponent = _ref.renderSubComponent,
    getRowCanExpand = _ref.getRowCanExpand,
    defaultExpanded = _ref.defaultExpanded,
    propExpanded = _ref.expanded,
    propOnExpandedChange = _ref.onExpandedChange;
  var _React$useState = React.useState(defaultExpanded || {}),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    expanded = _React$useState2[0],
    setExpanded = _React$useState2[1];
  var table = useReactTable({
    getRowId: function getRowId(originalRow, index) {
      // @ts-ignore
      var rowId = (originalRow === null || originalRow === void 0 ? void 0 : originalRow.id) || index;
      return rowId;
    },
    data: data,
    columns: columns,
    getRowCanExpand: getRowCanExpand,
    getCoreRowModel: getCoreRowModel(),
    state: {
      expanded: expanded
    },
    onExpandedChange: setExpanded,
    getExpandedRowModel: getExpandedRowModel()
  });
  React.useImperativeHandle(ref, function () {
    return {
      resetExpanded: function resetExpanded() {
        table.resetExpanded();
      }
    };
  });

  // 响应可控展开状态
  useEffect(function () {
    setExpanded(propExpanded || defaultExpanded || {});
  }, [defaultExpanded, propExpanded]);

  // 通知外部展开状态变化
  useEffect(function () {
    propOnExpandedChange === null || propOnExpandedChange === void 0 || propOnExpandedChange(expanded);
  }, [expanded, propOnExpandedChange]);
  return /*#__PURE__*/_jsxs(Table, {
    className: cn('font-IBM', className),
    height: height,
    children: [/*#__PURE__*/_jsx(TableHeader, {
      children: table.getHeaderGroups().map(function (headerGroup, headerGroupIndex) {
        return /*#__PURE__*/_jsx(TableRow, {
          children: headerGroup.headers.map(function (header, headerIndex) {
            return /*#__PURE__*/_jsx(TableHead, {
              className: cn('p-[12px] gap-[8px]', 'font-IBM', 'text-[12px]', 'font-[400]', 'leading-bds-line-height-12', 'text-base-bds-gray-t2', isLite ? 'border-solid border-b border-base-bds-gray-ele-border' : 'bg-base-bds-gray-bg-edge'),
              children: header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())
            }, (header === null || header === void 0 ? void 0 : header.id) || headerIndex);
          })
        }, (headerGroup === null || headerGroup === void 0 ? void 0 : headerGroup.id) || headerGroupIndex);
      })
    }), /*#__PURE__*/_jsxs(TableBody, {
      className: "relative",
      children: [error ? /*#__PURE__*/_jsx(TableRow, {
        children: /*#__PURE__*/_jsx(TableCell, {
          colSpan: columns.length,
          className: "w-full",
          children: /*#__PURE__*/_jsx("div", {
            className: "h-[300px] pt-[71px] mx-auto flex flex-col items-center gap-[16px]",
            children: /*#__PURE__*/_jsx(Empty, {
              title: '',
              subTitle: "".concat(errorText || ERROR_INFO[error.type].text, " (Code: ").concat(error.code, ")"),
              status: error.type === ErrorTypeStr.NETWORK ? 'networkError' : 'databaseError'
            })
          })
        })
      }) : (_table$getRowModel$ro = table.getRowModel().rows) !== null && _table$getRowModel$ro !== void 0 && _table$getRowModel$ro.length ? table.getRowModel().rows.map(function (row, rowIndex) {
        return /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(TableRow, {
            "data-state": row.getIsSelected() && 'selected',
            className: cn('transition', showRowSelection ? 'hover:bg-base-bds-trans-hover' : 'hover:bg-inherit', onRowClick ? 'cursor-pointer' : ''),
            onClick: function onClick(event) {
              return onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(event, row.id);
            },
            children: row.getVisibleCells().map(function (cell, cellIndex) {
              return /*#__PURE__*/_jsx(TableCell, {
                className: cn('px-[12px]', cellSpaceStyle === 'normal' && 'py-[12px]', cellSpaceStyle === 'small' && 'py-[8px]', cellSpaceStyle === 'large' && 'py-[16px]', 'font-IBM', 'text-[14px]', 'font-[500]', 'leading-bds-line-height-14', 'text-base-bds-gray-t1-title', rowSplitStyle !== 'none' && 'border-solid border-b', rowSplitStyle === 'strong' ? 'border-base-bds-gray-ele-border' : 'border-base-bds-gray-ele-line'),
                children: flexRender(cell.column.columnDef.cell, cell.getContext())
              }, (cell === null || cell === void 0 ? void 0 : cell.id) || cellIndex);
            })
          }), !!row.getIsExpanded() && /*#__PURE__*/_jsx(TableRow, {
            children: /*#__PURE__*/_jsx(TableCell, {
              colSpan: columns.length,
              className: cn('px-[40px] py-[16px]', 'font-IBM', 'text-base-bds-gray-t1-title', 'bg-base-bds-gray-bg-edge'),
              children: renderSubComponent ? renderSubComponent({
                row: row
              }) : row.getValue('extend')
            })
          })]
        }, (row === null || row === void 0 ? void 0 : row.id) || rowIndex);
      }) : /*#__PURE__*/_jsx(TableRow, {
        children: /*#__PURE__*/_jsx(TableCell, {
          colSpan: columns.length,
          className: "w-full",
          children: /*#__PURE__*/_jsx("div", {
            className: "h-[300px] pt-[71px] mx-auto flex flex-col items-center gap-[16px]",
            children: /*#__PURE__*/_jsx(Empty, {
              title: '',
              subTitle: emptyText
            })
          })
        })
      }), loading && /*#__PURE__*/_jsx(TableRow, {
        children: /*#__PURE__*/_jsx(TableCell, {
          colSpan: columns.length,
          className: "w-full",
          children: /*#__PURE__*/_jsx("div", {
            className: cn('absolute left-0 top-0 w-full h-full opacity-90 bg-base-bds-gray-bg-card flex justify-center items-center'),
            children: /*#__PURE__*/_jsx(Spin, {})
          })
        })
      })]
    })]
  });
}
export default /*#__PURE__*/React.forwardRef(DataTable);